var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 812,
    height: 651,
    viewBox: "0 0 812 651",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M340.201 294.167L518.806 190.992L340.201 87.8305V294.167Z",
    fill: "url(#paint0_linear_71_48)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M161.595 190.992L340.201 294.167V87.8305L161.595 190.992Z",
    fill: "url(#paint1_linear_71_48)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M340.766 293.842L162.16 190.681V397.018L340.766 293.842Z",
    fill: "url(#paint2_linear_71_48)"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M162.16 397.018L340.766 500.179V293.842L162.16 397.018Z",
    fill: "url(#paint3_linear_71_48)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6,
    d: "M340.78 293.842V500.179L519.371 397.018L340.78 293.842Z",
    fill: "url(#paint4_linear_71_48)"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M519.371 190.681L340.78 293.842L519.371 397.018V190.681Z",
    fill: "url(#paint5_linear_71_48)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M453.773 228.45L340.314 162.916L226.742 228.506L227.095 228.718V359.517L340.653 425.108V425.065L340.667 425.108L454.239 359.517V228.309L453.773 228.45Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M340.017 293.758L518.086 190.893L696.155 293.758V499.487L518.086 602.351L340.017 499.487V293.758Z",
    fill: "url(#paint6_linear_71_48)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M-0.684692 228.012L113.311 162.167L227.292 228.012V359.715L113.311 425.56L-0.684692 359.715V228.012Z",
    fill: "url(#paint7_linear_71_48)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_71_48",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -29,
    y: 0,
    width: 841,
    height: 651
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M811.548 0H-29V651H811.548V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_71_48)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M875 397.032L697.016 499.84L519.018 397.032V191.387L697.016 88.5653L875 191.387V397.032Z",
    fill: "url(#paint8_linear_71_48)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_71_48",
    x1: 429.51,
    y1: 294.167,
    x2: 429.51,
    y2: 87.8305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E44C33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0067CD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_71_48",
    x1: 250.905,
    y1: 294.167,
    x2: 250.905,
    y2: 87.8305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5DDF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253E88"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_71_48",
    x1: 251.456,
    y1: 397.018,
    x2: 251.456,
    y2: 190.667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AAAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EB4E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_71_48",
    x1: 251.456,
    y1: 500.179,
    x2: 251.456,
    y2: 293.842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5DDF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EB4E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_71_48",
    x1: 430.075,
    y1: 500.179,
    x2: 430.075,
    y2: 293.842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E44C33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0067CD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_71_48",
    x1: 430.075,
    y1: 397.018,
    x2: 430.075,
    y2: 190.667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5DDF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F69220"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_71_48",
    x1: 433.564,
    y1: 251.17,
    x2: 645.565,
    y2: 615.622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5DDF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66CDE1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_71_48",
    x1: 59.1941,
    y1: 200.755,
    x2: 194.917,
    y2: 434.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5DDF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66CDE1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_71_48",
    x1: 781.496,
    y1: 439.605,
    x2: 569.579,
    y2: 75.3091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5DDF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66CDE1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame5);
export default __webpack_public_path__ + "static/media/frame-5.82f1b11b735099920b8948cec995eb19.svg";
export { ForwardRef as ReactComponent };